import { IsEmail } from 'class-validator'
import { t } from 'i18next'
import { BaseModel } from '../base.model'

export class RequestMagicLinkModel extends BaseModel {
    @IsEmail(undefined, { message: t('validation.invalidFormat') as string })
    public email: string = ''
}
